import { TRANSLATION_ENDPOINTS } from './endpoints.js';
/**
 * Translation API Client
 * Encapsulates all translation-related API calls.
 */
export class TranslationClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get a stream of translation results.
     * Corresponds to: POST /api/translation/stream
     */
    async translateStream(request) {
        const options = {
            method: 'POST',
            body: JSON.stringify(request),
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000, // 30 seconds timeout for all translation models
        };
        const result = await this.httpClient.requestStream(TRANSLATION_ENDPOINTS.TRANSLATE_STREAM, options);
        // httpClient.requestStream now throws on any error and guarantees a non-null stream on success.
        // The 'error' property in the returned object is always null if no exception is thrown.
        return result.stream;
    }
}
//# sourceMappingURL=client.js.map